import React from 'react';
import {MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import {Icon} from 'leaflet'
import 'leaflet/dist/leaflet.css';
import { MapWrapper } from '../../StyledComponets';

function MapLocation(props) {
  return (
    <MapWrapper>
       <MapContainer 
        center={props.position} 
        zoom={95} 
        scrollWheelZoom={false}
        style={{ height: '500px', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={props.position} icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}>
        <Popup>
        {`Lat:${props.position[0]},Long:${props.position[1]}`}
      </Popup>
        </Marker>
      </MapContainer>
      </MapWrapper>
  );
}

export default MapLocation;
